import { render, staticRenderFns } from "./StudentAmount.vue?vue&type=template&id=5152ae8f&scoped=true"
import script from "./StudentAmount.vue?vue&type=script&lang=js"
export * from "./StudentAmount.vue?vue&type=script&lang=js"
import style0 from "./StudentAmount.vue?vue&type=style&index=0&id=5152ae8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152ae8f",
  null
  
)

export default component.exports